import { DEFAULT_QUERY_OPTIONS, useQueryWithBoundary } from '@/shared/lib/query';
import { glossaryKeys } from '@/shared/lib/query/queryKeys';

import { fetchGlossaryTermDetail, type GlossaryTermDetailResponse } from '@/features/glossary/api';

export const useGlossaryTermDetail = (termFqn: string, enabled: boolean = true) => {
  return useQueryWithBoundary<GlossaryTermDetailResponse>({
    queryKey: glossaryKeys.termDetailByFqn(termFqn),
    queryFn: () => fetchGlossaryTermDetail(termFqn),
    enabled: !!termFqn && enabled,
    staleTime: 5 * 60 * 1000,
    ...DEFAULT_QUERY_OPTIONS,
  });
};
